import { defineStore } from 'pinia'
import axiosIns from '@/composables/axios'
import { useNotificationStore } from '@/store/notification'

export const useNotificationsStore = defineStore('notifications', {
    state: () => ({
        notifications: [],
        loading: false,
    }),

    actions: {
        async getNotifications() {
            const notificationStore = useNotificationStore()
            try {
                const { data } = await axiosIns.get('notification')

                const typeConfig: Record<string, { icon: string; color: string }> = {
                    system: {
                        icon: 'tabler-bell',
                        color: 'primary',
                    },
                    calendar: {
                        icon: 'tabler-calendar',
                        color: 'info',
                    },
                    order: {
                        icon: 'tabler-message',
                        color: 'success',
                    },
                    announcement: {
                        icon: 'tabler-flag',
                        color: 'warning',
                    },

                    default: {
                        icon: 'tabler-bell',
                        color: 'secondary',
                    },
                }

                this.notifications = data.map((n: any) => ({
                    ...n,

                    icon: typeConfig[n.type]?.icon ?? typeConfig.default.icon,
                    color: typeConfig[n.type]?.color ?? typeConfig.default.color,

                    subtitle: n.message,
                    date: n.createdAt,
                }))
            } catch (error) {
                notificationStore.notifyFail({
                    title: 'Erro',
                    text: 'Erro ao carregar notificações',
                })
            }
        },

        async createNotification(data: {
            title: string;
            message: string;
            system: boolean;
            email: boolean;
            whatsapp: boolean;
            companyIds: number[];
        }) {
            const notificationStore = useNotificationStore()
            try {
                this.loading = true
                const response = await axiosIns.post("notification", data)
                notificationStore.notifySuccess({
                    text: 'Notificação enviada com sucesso!',
                    title: 'Sucesso',
                })
                this.loading = false
                return response.data;
            } catch (error) {
                notificationStore.notifyFail({
                    text: 'Erro ao enviar notificação',
                    title: 'Erro',
                })
                this.loading = false
                throw error
            } 
        },
        async updateNotification(id: number, data: any) {
            const notificationStore = useNotificationStore()
            try {
                const response = await axiosIns.put(`notification/${id}`, data)
                this.getNotifications()
                return response.data
            } catch (error) {
                notificationStore.notifyFail({
                    text: 'Erro ao atualizar notificação',
                    title: 'Erro',
                })
                throw error
            }
        },

        async deleteNotification(id: number) {
            const notificationStore = useNotificationStore()
            try {
                const response = await axiosIns.delete(`notification/${id}`)

                notificationStore.notifySuccess({
                    text: 'Notificação removida com sucesso',
                    title: 'Sucesso',
                })

                this.getNotifications()

                return response.data
            } catch (error) {
                notificationStore.notifyFail({
                    text: 'Erro ao remover notificação',
                    title: 'Erro',
                })
                throw error
            }
        },

        async markAsRead(id: number) {
            const notificationStore = useNotificationStore()
            try {
                const response = await axiosIns.put(`notification/${id}/read`)
                this.getNotifications()
                return response.data
            } catch (error) {
                notificationStore.notifyFail({
                    text: 'Erro ao marcar notificação como lida',
                    title: 'Erro',
                })
                throw error
            }
        },

        async deleteMultiple(ids: number[]) {
            const notificationStore = useNotificationStore()
            try {
                const response = await axiosIns.delete('notification/multiple', {
                    data: { ids }
                })
                this.getNotifications()
                return response.data
            } catch (error) {
                notificationStore.notifyFail({
                    text: 'Erro ao deletar notificações',
                    title: 'Erro',
                })
                throw error
            }
        },
    }
})

